(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerTitleSearch', CustomerTitleSearch);

    CustomerTitleSearch.$inject = ['$resource'];

    function CustomerTitleSearch($resource) {
        var resourceUrl =  'api/_search/customer-titles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
